import { AxiosError } from "axios";
import { useContext } from "react";
import useSWR from "swr";
import { GetReferralRewardsHistory200Response } from "../../../codegen-api";
import { AuthContext } from "../../../contexts/AuthContext";
import { APIEndpointEnum } from "../../../enums/endpoint";
import { authApi } from "../../../services/api/apiFetcher";

export const useRewardHistory = () => {
  const { apiKey, apiSecret } = useContext(AuthContext);
  const fetcher = authApi(apiKey, apiSecret);

  return useSWR<GetReferralRewardsHistory200Response, AxiosError>(
    apiKey ? [APIEndpointEnum.REFERRAL_REWARD_HISTORY, apiKey] : undefined,
    async () => (await (await fetcher.getReferralRewardsHistory())()).data
  );
};
